import CardLogin from 'app/components/Layouts/CardLogin';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import useOTP from 'app/pages/Authorization/OTP/useOTP';
import { descText, infoText, btnBox, resendLink } from './OTP.sx';
import OTPInput from 'react-otp-input';
import styles from './otp.module.css';
import { errorText, warningBox } from 'app/components/LoginForm/LoginForm.sx';
import WarningIcon from 'app/components/Icons/WarningIcon';
import BackButton from 'app/components/BackButton';
import CountdownTimer from 'app/components/CountdownTimer';
import logger from 'app/utils/logger';

const OTP = () => {
  const { t, otp, data, dataOtp, handleSubmitForm, handleChange, resentOtp, isLoadingOtp, timer, isSuccessOtp } =
    useOTP();

  // if (isLoadingOtp) {
  //   return (
  //     <Box
  //       sx={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         overflow: 'hidden',
  //         height: '100%',
  //       }}
  //     >
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  return (
    <CardLogin>
      <form
        style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}
        onSubmit={handleSubmitForm}
      >
        <Box>
          <Typography sx={infoText}>{t('otp.confirmOTP')}</Typography>
          <Typography sx={descText}>{t('otp.confirmNumberOTP', { number: data?.phone })}</Typography>
          <OTPInput
            value={otp}
            onChange={handleChange}
            numInputs={data?.form_id === 'otp' ? 4 : data?.form_id === 'login_totp' && 6}
            renderInput={(props) => <input {...props} className={styles.otpInput} />}
            shouldAutoFocus={true}
          />
          {isLoadingOtp ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                height: '100%',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <CountdownTimer
              repeat={resentOtp}
              otp={true}
              timerTime={dataOtp === undefined ? data?.timer : dataOtp?.timer}
              errorCase={dataOtp?.result === 'error'}
            />
          )}
        </Box>
        {dataOtp?.error && (
          <Box sx={warningBox}>
            <WarningIcon sx={{ mr: '16px' }} />
            <Typography sx={errorText}>{dataOtp?.error && dataOtp?.error.text}</Typography>
          </Box>
        )}
        <Box sx={btnBox}>
          <Button
            type={'submit'}
            disabled={
              (data?.form_id === 'otp'
                ? !(otp?.length === 4)
                : data?.form_id === 'login_totp' && !(otp?.length === 6)) || isLoadingOtp
            }
            variant={'contained'}
            sx={{ mb: '12px' }}
          >
            {isLoadingOtp ? (
              <CircularProgress sx={{ width: '24px !important', height: '24px !important' }} />
            ) : (
              t('login.continue')
            )}
          </Button>
          <BackButton text={'otp.back'} tab={data?.form_id === 'otp' ? 0 : data?.form_id === 'login_totp' && 2} />
        </Box>
      </form>
    </CardLogin>
  );
};

export default OTP;
